var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#262626",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.277 22.093.928-.928a.56.56 0 0 0 0-.796l-7.272-7.271h16.005c.31 0 .562-.252.562-.563v-1.312a.563.563 0 0 0-.562-.563H5.933l7.272-7.272a.56.56 0 0 0 0-.795l-.928-.928a.563.563 0 0 0-.796 0L1.665 11.48a.563.563 0 0 0 0 .796l9.816 9.816c.22.22.576.22.796 0"
  })));
};
export default SvgArrowLeft;